export default __webpack_public_path__ + "static/media/profile.bf008776.svg";